import { FC } from 'react';

import './routing-version-status-badge.css';

// API statuses of a routing config version; 'published' is shown as "Active" per product wording.
const STATUS_LABELS: Record<string, string> = {
  published: 'Active',
  draft: 'Draft',
  archived: 'Archived',
};

interface IProps {
  status: string;
}

const RoutingVersionStatusBadge: FC<IProps> = ({ status }) => {
  return (
    <span className={`routing-version-status-badge routing-version-status-badge--${status}`}>
      {STATUS_LABELS[status] ?? status}
    </span>
  );
};

export default RoutingVersionStatusBadge;
